import React from "react";
import MineTailingsInfoTabs from "./MineTailingsInfoTabs";

export const DamsDetailsPage = () => <MineTailingsInfoTabs enabledTabs={["dam"]} />;

export default DamsDetailsPage;
